import React, { createContext, useContext, useState } from "react";

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([]);

  // ✅ ADD TO CART
  const addToCart = (product) => {
    setCartItems((prev) => {
      const existing = prev.find((item) => item.id === product.id);

      if (existing) {
        // Increase qty if already exists
        return prev.map((item) =>
          item.id === product.id
            ? { ...item, qty: item.qty + 1 }
            : item
        );
      }

      // New product with qty 1
      return [...prev, { ...product, qty: 1 }];
    });
  };

  // ✅ REMOVE
  const removeFromCart = (id) => {
    setCartItems((prev) =>
      prev.filter((item) => item._id !== id)
    );
  };

  // ✅ UPDATE QTY
  const updateQty = (id, newQty) => {
    if (newQty < 1) return; // prevent negative

    setCartItems((prev) =>
      prev.map((item) =>
        item.id === id
          ? { ...item, qty: newQty }
          : item
      )
    );
  };

  // ✅ SUBTOTAL
  const subtotal = cartItems.reduce(
    (total, item) => total + item.price * item.qty,
    0
  );

  return (
    <CartContext.Provider
      value={{
        cartItems,
        addToCart,
        removeFromCart,
        updateQty,
        subtotal,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);